import dayjs from "dayjs";

export const daysFilterValue = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').add(0, 'day')),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().startOf('day').add(-1, 'day')),
    value2: new Date(dayjs().startOf('day').add(0, 'day')),
  },
  {
    text: 'currentWeek',
    value: new Date(dayjs().startOf('day').day(1)),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
];
